/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleEvaluationRequestTaskEvaluationsAnyOf } from './moduleEvaluationRequestTaskEvaluationsAnyOf';

export type ModuleEvaluationRequestTaskEvaluations = ModuleEvaluationRequestTaskEvaluationsAnyOf | null;
